import { RETURN_SUMMARY_SESSION_STORAGE_KEY } from '../constants/general';
import { getWindow, roundValueAndTrim } from './general';
import { setSessionStorage } from './storage-helper';
import { extractAddressInfo, getFieldByLineItemId, getLORPShipFromAddress, getSsReturnCreateShipFromAddress, } from '.';
export var persistReturnSummaryinfo = function (returnSummaryData, navigate) {
    try {
        setSessionStorage(RETURN_SUMMARY_SESSION_STORAGE_KEY, returnSummaryData);
        if (getWindow()) {
            navigate('/myaccount/return-summary', { replace: true });
        }
    }
    catch (error) {
        // eslint-disable-next-line no-console
        console.error('Failed to set session storage:', error);
    }
};
// TODO will we even need this single return function once we move to the new shipments object?
export var getSingleReturnShipment = function (selectedReturnItems, isLORPMethod, returnBoxes, orderDetailsV2, emailId, deliveryDictionary, ssrHrtvRespLineItems, shipmentType, lorpContactDetails) {
    var _a;
    var totalWeight = selectedReturnItems.reduce(function (acc, nextItem) {
        return acc + (nextItem.itemWeight || 0) * (nextItem.returnQuantity || 0);
    }, 0);
    var noOfBoxes = isLORPMethod ? 1 : returnBoxes;
    var shipFromAddress = isLORPMethod
        ? getLORPShipFromAddress(lorpContactDetails || {}, orderDetailsV2.fulfillmentGroups, selectedReturnItems)
        : getSsReturnCreateShipFromAddress(emailId, selectedReturnItems, deliveryDictionary);
    var shipment = {
        itemWeight: roundValueAndTrim(totalWeight),
        mVendorNumber: ((_a = selectedReturnItems[0]) === null || _a === void 0 ? void 0 : _a.mVendorNumber) || '',
        noOfBoxes: noOfBoxes,
        lineItems: selectedReturnItems.map(function (item) { return ({
            lineItemId: item.lineItemId || '',
            poNumber: item.poNumber || '',
            sku: item.sku || '',
            returnQuantity: item.returnQuantity,
            returnReasonCode: item.returnReasonCode,
            productType: item.productType,
            rtvTokenId: getFieldByLineItemId(ssrHrtvRespLineItems, item.lineItemId || '', 'tokenId'),
            returnDispCode: String(getFieldByLineItemId(ssrHrtvRespLineItems, item.lineItemId || '', 'dispositionCd')),
            returnPolicyId: getFieldByLineItemId(ssrHrtvRespLineItems, item.lineItemId || '', 'policyId'),
            itemDescription: item.itemDescription || '',
            hazmatItem: item.hazmatItem || false,
        }); }),
        shipFromAddress: shipFromAddress,
        shipToAddress: extractAddressInfo(ssrHrtvRespLineItems),
        shipmentType: shipmentType,
    };
    return [shipment];
};
export var getMultiReturnShipments = function (emailId, deliveryDictionary, vendorReturnAddresses, shipmentType, shipmentGroupedLineItems, multipleReturnBoxes) {
    // Dont need to worry about LORP method here, as it is not supported for multi-address returns yet
    return (shipmentGroupedLineItems === null || shipmentGroupedLineItems === void 0 ? void 0 : shipmentGroupedLineItems.map(function (shipmentLineItems, index) {
        var _a;
        var totalWeight = shipmentLineItems.reduce(function (acc, item) { return acc + (item.itemWeight || 0) * (item.returnQuantity || 0); }, 0);
        var shipFromAddress = getSsReturnCreateShipFromAddress(emailId, shipmentLineItems, deliveryDictionary);
        return {
            itemWeight: roundValueAndTrim(totalWeight),
            mVendorNumber: ((_a = shipmentLineItems[0]) === null || _a === void 0 ? void 0 : _a.mVendorNumber) || '',
            noOfBoxes: (multipleReturnBoxes === null || multipleReturnBoxes === void 0 ? void 0 : multipleReturnBoxes[index]) || 0,
            lineItems: shipmentLineItems.map(function (item) {
                var hrtvShipmentsLineItem = vendorReturnAddresses[index].lineItems.find(function (lineItem) { return lineItem.lineItemId === item.lineItemId; });
                return {
                    lineItemId: item.lineItemId || '',
                    poNumber: item.poNumber || '',
                    sku: item.sku || '',
                    returnQuantity: item.returnQuantity,
                    returnReasonCode: item.returnReasonCode,
                    productType: item.productType,
                    rtvTokenId: (hrtvShipmentsLineItem === null || hrtvShipmentsLineItem === void 0 ? void 0 : hrtvShipmentsLineItem.rtvTokenId) || '',
                    returnDispCode: (hrtvShipmentsLineItem === null || hrtvShipmentsLineItem === void 0 ? void 0 : hrtvShipmentsLineItem.returnDispCode) || '',
                    returnPolicyId: (hrtvShipmentsLineItem === null || hrtvShipmentsLineItem === void 0 ? void 0 : hrtvShipmentsLineItem.returnPolicyId) || 0,
                    itemDescription: item.itemDescription || '',
                    hazmatItem: item.hazmatItem || false,
                };
            }),
            shipFromAddress: shipFromAddress,
            shipToAddress: vendorReturnAddresses[index].shipToAddress,
            shipmentType: shipmentType,
        };
    })) || [];
};
